<header class="cg-topbar">
    <div class="cg-topbar-start">
        <button type="button" class="cg-icon-button" (click)="appMain.onMenuButtonClick($event)" aria-label="Abrir o cerrar menú">
            <lucide-icon [img]="Menu" [size]="20"></lucide-icon>
        </button>
        <app-breadcrumb></app-breadcrumb>
    </div>
    <div class="cg-topbar-end">
        <button type="button" class="cg-icon-button" (click)="toggleTheme()"
            [attr.aria-label]="themeService.scheme === 'dark' ? 'Activar modo claro' : 'Activar modo oscuro'"
            [title]="themeService.scheme === 'dark' ? 'Modo claro' : 'Modo oscuro'">
            <lucide-icon [img]="themeService.scheme === 'dark' ? Sun : Moon" [size]="20"></lucide-icon>
        </button>
    <div #profile class="cg-profile" [class.cg-profile-open]="appMain.activeTopbarItem === profile">
        <button type="button" class="cg-profile-trigger" (click)="appMain.onTopbarItemClick($event, profile)">
            <p-avatar [label]="avatar || 'CG'" shape="circle"></p-avatar>
            <span class="cg-profile-copy"><strong>{{ displayName || 'Usuario' }}</strong><small>Administración</small></span>
            <lucide-icon [img]="ChevronDown" [size]="16"></lucide-icon>
        </button>
        <ul class="cg-profile-menu" *ngIf="appMain.activeTopbarItem === profile">
            <li><a routerLink="/account/configuration"><lucide-icon [img]="Settings" [size]="17"></lucide-icon><span>Configuración</span></a></li>
            <li class="cg-profile-menu-separator"><button type="button" (click)="logout()"><lucide-icon [img]="LogOut" [size]="17"></lucide-icon><span>Salir</span></button></li>
        </ul>
    </div>
    </div>
</header>
